import CityPageTemplate from "../city-template/CityPageTemplate";
import { pomonaConfig } from "./data";

export default function PomonaPage() {
  return <CityPageTemplate config={pomonaConfig} />;
}